import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ChevronUpDownIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 10, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 15) / 10}
      viewBox="0 0 10 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.02282 14.4782C4.92844 14.4788 4.83488 14.4607 4.74751 14.425C4.66014 14.3893 4.58067 14.3367 4.51366 14.2703L0.210901 9.9675C0.0758633 9.83246 0 9.64931 0 9.45834C0 9.26737 0.0758633 9.08422 0.210901 8.94918C0.345938 8.81414 0.529089 8.73828 0.72006 8.73828C0.911032 8.73828 1.09418 8.81414 1.22922 8.94918L5.02282 12.75L8.81641 8.95635C8.9536 8.83887 9.13007 8.77748 9.31055 8.78445C9.49104 8.79142 9.66224 8.86624 9.78996 8.99396C9.91768 9.12167 9.99249 9.29288 9.99946 9.47336C10.0064 9.65385 9.94505 9.83031 9.82756 9.9675L5.52481 14.2703C5.39123 14.4027 5.21095 14.4774 5.02282 14.4782Z"
        fill="currentColor"
      />
      <path
        d="M5.02282 -0.00166178C4.92844 -0.00220728 4.83488 0.015882 4.74751 0.0515695C4.66014 0.0872569 4.58067 0.13984 4.51366 0.206305L0.210901 4.50906C0.0758633 4.6441 0 4.82725 0 5.01822C0 5.20919 0.0758633 5.39234 0.210901 5.52738C0.345938 5.66242 0.529089 5.73828 0.72006 5.73828C0.911032 5.73828 1.09418 5.66242 1.22922 5.52738L5.02282 1.72661L8.81641 5.52021C8.9536 5.63769 9.13007 5.69908 9.31055 5.69211C9.49104 5.68514 9.66224 5.61032 9.78996 5.48261C9.91768 5.35489 9.99249 5.18368 9.99946 5.0032C10.0064 4.82272 9.94505 4.64625 9.82756 4.50906L5.52481 0.206305C5.39123 0.0738196 5.21095 -0.000869751 5.02282 -0.00166178Z"
        fill="currentColor"
      />
    </svg>
  )
})

ChevronUpDownIcon.displayName = 'ChevronUpDownIcon'
